import { createClient } from '@supabase/supabase-js'

// Get env vars - works in both dev and production
const supabaseUrl = typeof process !== 'undefined' && process.env?.VITE_SUPABASE_URL 
  ? process.env.VITE_SUPABASE_URL 
  : ''
const supabaseServiceKey = typeof process !== 'undefined' && process.env?.VITE_SUPABASE_SERVICE_ROLE_KEY
  ? process.env.VITE_SUPABASE_SERVICE_ROLE_KEY
  : ''

// Admin client bypasses RLS - use only for admin operations!
// Note: In client-side code, this will be null (service key should not be exposed to client)
// Admin operations should be done through API endpoints
export const supabaseAdmin = supabaseServiceKey && supabaseUrl
  ? createClient(supabaseUrl, supabaseServiceKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    })
  : null
